let Weekday = /*#__PURE__*/function (Weekday) {
  Weekday[Weekday["Sunday"] = 0] = "Sunday";
  Weekday[Weekday["Monday"] = 1] = "Monday";
  Weekday[Weekday["Tuesday"] = 2] = "Tuesday";
  Weekday[Weekday["Wednesday"] = 3] = "Wednesday";
  Weekday[Weekday["Thursday"] = 4] = "Thursday";
  Weekday[Weekday["Friday"] = 5] = "Friday";
  Weekday[Weekday["Saturday"] = 6] = "Saturday";
  return Weekday;
}({});
const DEFAULT_WEEK_START_DAY = Weekday.Sunday;
let DiscountMethod = /*#__PURE__*/function (DiscountMethod) {
  DiscountMethod["Code"] = "Code";
  DiscountMethod["Automatic"] = "Automatic";
  return DiscountMethod;
}({});
let DiscountClass = /*#__PURE__*/function (DiscountClass) {
  DiscountClass["Product"] = "PRODUCT";
  DiscountClass["Order"] = "ORDER";
  DiscountClass["Shipping"] = "SHIPPING";
  return DiscountClass;
}({});
const DEFAULT_DISCOUNT_CODE_LENGTH = 12;
let RecurringPaymentType = /*#__PURE__*/function (RecurringPaymentType) {
  RecurringPaymentType["FirstPayment"] = "FIRST_PAYMENT";
  RecurringPaymentType["MultiplePayments"] = "MULTIPLE_PAYMENTS";
  RecurringPaymentType["AllPayments"] = "ALL_PAYMENTS";
  return RecurringPaymentType;
}({});
let RequirementType = /*#__PURE__*/function (RequirementType) {
  RequirementType["None"] = "NONE";
  RequirementType["Subtotal"] = "SUBTOTAL";
  RequirementType["Quantity"] = "QUANTITY";
  return RequirementType;
}({});
let AppliesTo = /*#__PURE__*/function (AppliesTo) {
  AppliesTo["Order"] = "ORDER";
  AppliesTo["Products"] = "PRODUCTS";
  AppliesTo["Collections"] = "COLLECTIONS";
  return AppliesTo;
}({});
let CountrySelectionType = /*#__PURE__*/function (CountrySelectionType) {
  CountrySelectionType["AllCountries"] = "ALL_COUNTRIES";
  CountrySelectionType["SelectedCountries"] = "SELECTED_COUNTRIES";
  return CountrySelectionType;
}({});
let DiscountStatus = /*#__PURE__*/function (DiscountStatus) {
  DiscountStatus["Active"] = "ACTIVE";
  DiscountStatus["Expired"] = "EXPIRED";
  DiscountStatus["Scheduled"] = "SCHEDULED";
  return DiscountStatus;
}({});
let PurchaseType = /*#__PURE__*/function (PurchaseType) {
  PurchaseType["OneTimePurchase"] = "ONE_TIME_PURCHASE";
  PurchaseType["Subscription"] = "SUBSCRIPTION";
  PurchaseType["Both"] = "BOTH";
  return PurchaseType;
}({});
let Eligibility = /*#__PURE__*/function (Eligibility) {
  Eligibility["Everyone"] = "EVERYONE";
  Eligibility["Customers"] = "CUSTOMERS";
  Eligibility["CustomerSegments"] = "CUSTOMER_SEGMENTS";
  return Eligibility;
}({});

export { AppliesTo, CountrySelectionType, DEFAULT_DISCOUNT_CODE_LENGTH, DEFAULT_WEEK_START_DAY, DiscountClass, DiscountMethod, DiscountStatus, Eligibility, PurchaseType, RecurringPaymentType, RequirementType, Weekday };
